import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ReactComponent as UpgradeProIcon } from "shared/assets/images/icon-upgrade-pro.svg";
import { openNewTab } from "shared/helpers/window-helpers";
import useSubscription, {
  subscriptionLabel,
} from "shared/hooks/useSubscription";
import { createCustomerPortalSession } from "shared/service/StrmService";

const MyPlan: React.FC = () => {
  const { t } = useTranslation();
  const { currentPlan, paidPlan } = useSubscription();

  const onClick = async () => {
    if (paidPlan) {
      try {
        const response: any = await createCustomerPortalSession();
        if (response.portalUrl) {
          openNewTab(response.portalUrl);
        } else {
          toast.error<string>(
            t("pages.Pricing.errors.unableToCreatePortalSession")
          );
        }
      } catch (error) {
        toast.error<string>(
          t("pages.Pricing.errors.unableToCreatePortalSession")
        );
      }
    }
  };

  if (!currentPlan) return null;

  return (
    <div
      className="my-plan"
      onClick={onClick}
      style={{
        cursor: paidPlan ? "pointer" : "default",
      }}
    >
      <div className="icon" aria-hidden>
        <UpgradeProIcon />
      </div>
      <div className="content">
        <h3 className="title">
          <Trans i18nKey={t("components.Subscription.myPlanTitle")} />
        </h3>
        {currentPlan && (
          <span className="body-large " style={{ color: "#F2F2F2" }}>
            {t(subscriptionLabel[currentPlan])}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyPlan;
